export type Language = 'pt-BR' | 'en-US' | 'es-ES';
export const SUPPORTED_LANGUAGES: Language[] = ['pt-BR', 'en-US', 'es-ES'];
